import { defineMessages } from 'react-intl'

const scope = `procurify.platform.banking.hooks.useFormatTransactionFee`

export default defineMessages({
  freeLabel: {
    id: `${scope}.freeLabel`,
    defaultMessage: 'Free',
  },
})
